import { Outlet } from 'react-router-dom'

function PBFBaseLayout() {
  return <Outlet />
}

export default PBFBaseLayout
